import React, {createRef} from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage from '../../components/plain/PlainPage';
import FieldEnum from '../../components/plain/FieldEnum';
import FieldDate from '../../components/plain/FieldDate';
import FieldDecimal from '../../components/plain/FieldDecimal';
import FieldInteger from '../../components/plain/FieldInteger';
import FieldReference from '../../components/plain/FieldReference';
import FieldList_TableGroup from '../../components/plain/FieldList_TableGroup';

import {CLASS_REQUEST, CLASS_PROVIDER, CLASS_BOOK } from '../../util/consts/classes';
import {FORM_REQUEST_PLAIN, FORM_PROVIDER_TABLE, FORM_BOOK_TABLE} from '../../util/consts/forms';
import {PROVIDER_PLAIN_PATH, BOOK_PLAIN_PATH} from '../../util/routes';

class RequestPlainPage extends PlainPage {
	
	constructor(props) {
		super(props);
		this.formPath = FORM_REQUEST_PLAIN;
		this.formTitle = 'Запит';
		this.refQty = createRef();
		this.refAmount = createRef();
		this.buildInstanceCard = this.buildRequestCard;
	}
	componentDidMount = async () => {
		this.init( CLASS_REQUEST );
		document.title = 'BOM. ' + this.formTitle;
	}
	buildRequestCard = (requestInstance) => {
		let card = '';
		if( requestInstance.rootField.value.supplierRef.value ) {
			let supplierCard = requestInstance.rootField.value.supplierRef.value.card;
			if( supplierCard )
				card += supplierCard;
		}
		return card;
	}
	
	handleInstanceChange = async (event) => {
		super.handleInstanceChange(event);
		let field = event.field;
		let fieldRequestItem = this.instance.rootField.value.requestItem;
				
		let recalcSum = false;
		while( field != null ) {
			if( field == fieldRequestItem ) {
				recalcSum = true;
				break;
			} else {
				field = field.parent;
			}
		}
		if( recalcSum )
			this.recalculateSum();
	}
	recalculateSum = () => {
		let validSum = true;
		let sum = 0;
		let qty = 0;
		for(let item of this.instance.rootField.value.requestItem.value) {
			let itemQty = item.value.qty.value;
			let price = item.value.price.value;
			if( itemQty==null || price==null || itemQty=='' || price=='' || Number(itemQty) == NaN || Number(price) == NaN) {
				validSum = false;
				break;
			}
			itemQty = Number(itemQty);
			price = Number(price);
			qty += itemQty;
			sum += price * itemQty;
		}
		if( validSum ) {
			sum = Math.round(sum * 100) / 100
			this.instance.setFieldValue(this.instance.rootField.value.amount, sum);
			this.instance.setFieldValue(this.instance.rootField.value.qty, qty);
		} else {
			this.instance.setFieldValue(this.instance.rootField.value.qty, '');
			this.instance.setFieldValue(this.instance.rootField.value.amount, '');
		}
		if( this.refQty.current )
			this.refQty.current.setState({valueIsValid: validSum});
		if( this.refAmount.current )
			this.refAmount.current.setState({valueIsValid: validSum});
	}
	
	
	renderBody() {
		let instance = this.state.instance;
		let fieldGroup = instance.rootField;
		let readOnly = this.instanceReadOnly;
		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >

					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldDate instance={instance} path={'dateTime'} plain={this} parentField={fieldGroup} 
							readOnly={readOnly}
							styles={{ input: {flexGrow: '0', marginRight: '20px'} }}
						/>
						<FieldReference instance={instance} path={'supplierRef'} parentField={fieldGroup} plain={this} 
							readOnly={readOnly}
							styles={{ divMain: {flexGrow: '1'} }}
							refNodes={[
								{
									classId: CLASS_PROVIDER, plainFormPath: PROVIDER_PLAIN_PATH, 
									selectInstanceFormId: FORM_PROVIDER_TABLE,
									selectInstanceFormTitle: 'Постачальники'
								},
							]}
						/>
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldEnum instance={instance} path={'requestType'} parentField={fieldGroup} plain={this} 
							readOnly={readOnly}
							styles={{ select: {marginRight: '20px'} }}
						/>
						<FieldEnum instance={instance} path={'state'} parentField={fieldGroup} plain={this} 
							readOnly={readOnly}
							styles={{ select: {marginRight: '20px'} }}
						/>
						<FieldInteger ref={this.refQty} instance={instance} path={'qty'} parentField={fieldGroup} plain={this} 
							readOnly={true}
							styles={{ input: {width: '50px', marginRight: '20px'} }}
						/>
						<FieldDecimal ref={this.refAmount} instance={instance} path={'amount'} parentField={fieldGroup} plain={this} 
							readOnly={true}
							styles={{ input: {width: '100px'} }}
						/>
					</div>

					<FieldList_TableGroup instance={instance} path={'requestItem'} parentField={fieldGroup}
						plain={this} plainDirtyCounter={this.state.plainDirtyCounter} ignoreTitle={false}
						readOnly={readOnly} 
						table={{
							columns: [
								{ columnId: 'bookRef', styles: {tdHeader: {width: '80%'}},
									refNodes: [
										{
											classId: CLASS_BOOK, plainFormPath: BOOK_PLAIN_PATH, 
											selectInstanceFormId: FORM_BOOK_TABLE,
											selectInstanceFormTitle: 'Книги'
										}
									]
								},
								{ columnId: 'price', styles: {tdHeader: {width: '10%'}} },
								{ columnId: 'qty', styles: {tdHeader: {width: '10%'} } },
							],
						}}
						styles={{
							table: {width: '100%'},
							trHeader: {height: '43px'}
						}}
					/>

				</div>					
			</div>
		)
	}
}

export default RequestPlainPage;
